import {
    PortModel, LinkModel, LinkModelGenerics,
    DefaultLinkModel
} from '@projectstorm/react-diagrams';
import { AbstractModelFactory, BaseEntityEvent } from '@projectstorm/react-canvas-core';
import { MetricsNodeModel } from './MetricsNodeModel';
import { MetricsPortOptions } from './MetricsPortOptions';
import { getHashColor } from './metrics_util';
import { GDS_BREAK } from './util';

export class MetricsPortModel extends PortModel {
    properties: MetricsPortOptions;
    constructor(options: MetricsPortOptions) {
        super({
            type: 'metrics-port',
            ...options,
        });
        this.properties = options;
    }
    getOptions() {
        return this.properties;
    }
    getRqId() {
        return this.properties.rqId;
    }

    getJsName() {
        return this.properties.jsName || '';
    }
    getPropertyName() {
        return this.properties.propertyName || '';
    }
    isMemberPort() {
        let node = this.getNode() as MetricsNodeModel;
        return node.getMemberPorts().indexOf(this) !== -1
    }
    updateName(name: string) {
        if (this.properties) {
            this.properties.propertyName = name;
            this.parent.fireEvent({}, 'portUpdate');
        }
    }
    getModelName(): string {
        if (this.properties && this.properties?.propertyName) {
            return this.properties.propertyName;
        }
        throw 'no name';
    }
    getUniqueName() {
        return `${this.properties.name}`;
    }
    getConnectedLinks() {
        return Object.values(this.links).filter(x => x.getSourcePort() && x.getTargetPort());
    }
    canHaveMultiple() {
        // switch ((this.getParent() as MetricsNodeModel).getNodeType()) {
        // }
        return this.properties.multipleLink || false;
    }
    canLinkToPort(port: MetricsPortModel): boolean {
        if (port instanceof MetricsPortModel) {
            return !!this.properties.connectableTypes.find(v => {
                return port.properties.connectableTypes.indexOf(v) !== -1
            });
        }
        return false;
    }
    getValueName() {
        let node: MetricsNodeModel = this.getParent() as MetricsNodeModel;
        // switch (node.getNodeType()) {
        // }
        return this.getUniqueName();
    }
    getDefaultValue() {
        return this.properties.defaultValue;
    }
    getPortName() {
        return this.properties.propertyName;
    }
    getName() {
        return this.getPortName();
    }
    setDefaultValue(val: any) {
        this.properties.defaultValue = val;
    }
    getPortTypeName(whosAsking?: MetricsPortModel, whichNode?: MetricsNodeModel) {
        let type = this.getPortType(whosAsking, whichNode);
        switch (type) {
            case 'StringKeyword':
                return 'string';
            case 'NumberKeyword':
                return 'number';
            case 'BooleanKeyword':
                return 'boolean';
            default:
                return type;
        }
    }
    getPortType(whosAsking?: MetricsPortModel, whichNode?: MetricsNodeModel): string {
        let node: MetricsNodeModel = this.getParent() as MetricsNodeModel;
        // if (node) {
        //     switch (node.getNodeType()) {
        //     }
        // }
        if (this.properties.connectableTypes.length) {
            return JSON.stringify(this.properties.connectableTypes);
        }
        if (this.properties.propertyType)
            return this.properties.propertyType;
        return '';
    }
    isConnectedTo(port: MetricsPortModel) {
        return this.getConnectedLinks().some((v) => {
            return this.getOtherPort(v) === port;
        });
    }
    getOtherPorts(): MetricsPortModel[] {
        let links = this.getConnectedLinks();

        return links.map(link => {
            if (link) {
                if (link.getSourcePort() === this) {
                    return link.getTargetPort() as MetricsPortModel;
                }
                return link.getSourcePort() as MetricsPortModel;
            }
        }).filter(x => x) as MetricsPortModel[];
    }
    getOtherPort(link?: LinkModel<LinkModelGenerics>): MetricsPortModel | null {
        if (!link) {
            let links = this.getConnectedLinks();
            if (links.length > 0) {
                link = links[0];
            }
        }
        if (link) {
            if (link.getSourcePort() === this) {
                return link.getTargetPort() as MetricsPortModel;
            }
            return link.getSourcePort() as MetricsPortModel;
        }
        return null;
    }
    getColor() {
        if (this.properties.propertyType) {
            return getHashColor(this.getPortType());
        }
        return 'rgba(255, 255, 255, 0.1)';
    }
    createLinkModel(): DefaultLinkModel {
        let link = new DefaultLinkModel({
            curvyness: 0
        });
        let handler = (evt: any) => {
            console.log(evt)
            let linkModel = evt.entity as DefaultLinkModel;
            let sourcePort = linkModel.getSourcePort();
            let sourceNode = sourcePort ? sourcePort.getNode() as MetricsNodeModel : undefined;
            let targetPort = linkModel.getTargetPort();
            let targetNode = targetPort ? targetPort.getNode() as MetricsNodeModel : undefined;
            let node: MetricsNodeModel | undefined;

            if (node) {
                node.synchronizePorts();
            }
        }
        link.registerListener({
            sourcePortChanged: handler,
            targetPortChanged: handler,
            entityRemoved: handler
        });

        return link;
    }
    link<T extends LinkModel>(port: MetricsPortModel, factory?: AbstractModelFactory<T>): T {
        let link = this.createLinkModel();
        link.setSourcePort(this);
        link.setTargetPort(port);
        return link as any;
    }
    serialize() {
        return {
            ...super.serialize(),
            properties: this.properties
        };
    }

    deserialize(event: any): void {
        super.deserialize(event);
        this.properties = event.data.properties;
    }
}